module.exports = __webpack_public_path__ + "img/pingan.443643ee.png";